import React from 'react';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { SeoMeta } from '@/components/seo/SeoMeta';
import { useCMSContent } from '@/hooks/useCMSContent';
import { renderMarkdown, PageLoading } from './shared';

export const FAQPage = () => {
  const { content, loading } = useCMSContent();

  if (loading) return <PageLoading />;

  const faqContent = content?.footer?.faq_page || 'Innehållet har inte konfigurerats ännu. Gå till Admin > Footer för att redigera.';

  return (
    <div className="bg-[#F8FAFC] min-h-screen" data-testid="faq-page">
      <SeoMeta
        title="Vanliga frågor (FAQ)"
        description="Svar på vanliga frågor om att handla byggmaterial på ByggFynd: leverans, betalning, returer, konto och support."
        canonicalPath="/faq"
      />
      <div className="container-main py-8">
        <Breadcrumbs items={[{ label: 'FAQ' }]} />
        
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-black text-[#0F172A] mb-8">Vanliga frågor (FAQ)</h1>
          
          <div className="bg-white rounded-md shadow-sm p-8">
            <div className="prose max-w-none">
              {renderMarkdown(faqContent)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
